(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-forms-collection"]) return;
  try {
    
  (() => {
    const SELECTOR = '[data-all-forms-page]';

    const getViewportMode = () => {
      if (window.matchMedia('(min-width: 990px)').matches) return 'desktop';
      if (window.matchMedia('(min-width: 750px)').matches) return 'tablet';
      return 'mobile';
    };

    const storageKey = () => `slowform-all-forms-density-${getViewportMode()}`;

    const readStoredDensity = () => {
      try {
        return window.sessionStorage.getItem(storageKey()) === 'expanded';
      } catch (error) {
        return false;
      }
    };

    const writeStoredDensity = (expanded) => {
      try {
        window.sessionStorage.setItem(storageKey(), expanded ? 'expanded' : 'default');
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; the control still works.
      }
    };

    const opticalBounds = new WeakMap();
    const opticalAnalysis = new Map();
    const opticalResizeObservers = new WeakMap();

    const waitForImage = async (image) => {
      if (image.complete && image.naturalWidth > 0) {
        try {
          await image.decode?.();
        } catch (error) {
          // A completed image can still be measured when decode() is unavailable or rejects.
        }
        return;
      }

      await new Promise((resolve, reject) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', reject, { once: true });
      });
    };

    const findWeightedEdge = (weights, threshold, reverse = false) => {
      let accumulated = 0;

      if (reverse) {
        for (let index = weights.length - 1; index >= 0; index -= 1) {
          accumulated += weights[index];
          if (accumulated >= threshold) return index;
        }

        return weights.length - 1;
      }

      for (let index = 0; index < weights.length; index += 1) {
        accumulated += weights[index];
        if (accumulated >= threshold) return index;
      }

      return 0;
    };

    const analyseOpticalBounds = async (image) => {
      await waitForImage(image);

      const source = image.currentSrc || image.src;
      if (opticalAnalysis.has(source)) return opticalAnalysis.get(source);

      const analysisPromise = (async () => {
        const naturalWidth = image.naturalWidth;
        const naturalHeight = image.naturalHeight;

        if (!naturalWidth || !naturalHeight) throw new Error('Image dimensions are unavailable.');

        const maximumDimension = 320;
        const scale = Math.min(1, maximumDimension / Math.max(naturalWidth, naturalHeight));
        const width = Math.max(1, Math.round(naturalWidth * scale));
        const height = Math.max(1, Math.round(naturalHeight * scale));
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d', { willReadFrequently: true });

        if (!context) throw new Error('Canvas analysis is unavailable.');

        canvas.width = width;
        canvas.height = height;
        context.clearRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);

        const pixels = context.getImageData(0, 0, width, height).data;
        const columnWeights = new Float64Array(width);
        const rowWeights = new Float64Array(height);
        let totalWeight = 0;

        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const alpha = pixels[(y * width + x) * 4 + 3];
            if (alpha <= 4) continue;

            const weight = alpha / 255;
            columnWeights[x] += weight;
            rowWeights[y] += weight;
            totalWeight += weight;
          }
        }

        if (totalWeight <= 0) throw new Error('No visible pixels were found.');

        // Ignore isolated anti-aliased pixels and faint shadow fragments at the canvas edge.
        const trimWeight = totalWeight * 0.0025;
        let left = findWeightedEdge(columnWeights, trimWeight);
        let right = findWeightedEdge(columnWeights, trimWeight, true);
        let top = findWeightedEdge(rowWeights, trimWeight);
        let bottom = findWeightedEdge(rowWeights, trimWeight, true);

        if (right <= left || bottom <= top) {
          left = 0;
          top = 0;
          right = width - 1;
          bottom = height - 1;
        }

        const contentWidth = right - left + 1;
        const contentHeight = bottom - top + 1;
        const paddingX = Math.max(1, contentWidth * 0.035);
        const paddingY = Math.max(1, contentHeight * 0.035);

        left = Math.max(0, left - paddingX);
        right = Math.min(width, right + 1 + paddingX);
        top = Math.max(0, top - paddingY);
        bottom = Math.min(height, bottom + 1 + paddingY);

        return {
          canvasWidth: width,
          canvasHeight: height,
          x: left,
          y: top,
          width: Math.max(1, right - left),
          height: Math.max(1, bottom - top),
        };
      })();

      opticalAnalysis.set(source, analysisPromise);

      try {
        return await analysisPromise;
      } catch (error) {
        opticalAnalysis.delete(source);
        throw error;
      }
    };

    const readPercentage = (styles, property, fallback) => {
      const rawValue = styles.getPropertyValue(property).trim();
      const parsed = Number.parseFloat(rawValue);

      if (!Number.isFinite(parsed)) return fallback;
      return rawValue.endsWith('%') ? parsed / 100 : parsed;
    };

    const positionOpticalImage = (image) => {
      const bounds = opticalBounds.get(image);
      const media = image.closest('[data-all-forms-media]');

      if (!bounds || !media || media.clientWidth <= 0 || media.clientHeight <= 0) return;

      const styles = window.getComputedStyle(media);
      const objectSizeRatio = readPercentage(styles, '--all-forms-object-size', 0.5);
      const centerXRatio = readPercentage(styles, '--all-forms-optical-center-x', 0.5);
      const baselineYRatio = readPercentage(styles, '--all-forms-baseline-y', 0.76);
      const targetWidth = media.clientWidth * objectSizeRatio;
      const targetHeight = media.clientHeight * objectSizeRatio;
      const renderScale = Math.min(targetWidth / bounds.width, targetHeight / bounds.height);
      const renderedWidth = bounds.canvasWidth * renderScale;
      const renderedHeight = bounds.canvasHeight * renderScale;
      const visibleCenterX = (bounds.x + bounds.width / 2) * renderScale;
      const visibleBottomY = (bounds.y + bounds.height) * renderScale;

      image.style.width = `${renderedWidth}px`;
      image.style.height = `${renderedHeight}px`;
      image.style.left = `${media.clientWidth * centerXRatio - visibleCenterX}px`;
      image.style.top = `${media.clientHeight * baselineYRatio - visibleBottomY}px`;
      image.dataset.opticalReady = 'true';
    };

    const revealFallbackImage = (image) => {
      image.style.removeProperty('width');
      image.style.removeProperty('height');
      image.style.removeProperty('left');
      image.style.removeProperty('top');
      image.dataset.opticalReady = 'fallback';
    };

    const normalizeOpticalImage = async (image) => {
      if (!image || image.dataset.opticalProcessing === 'true') return;

      image.dataset.opticalProcessing = 'true';

      try {
        const bounds = await analyseOpticalBounds(image);
        opticalBounds.set(image, bounds);
        positionOpticalImage(image);
      } catch (error) {
        // If a CDN blocks pixel access, retain the bottom-aligned object-fit fallback.
        revealFallbackImage(image);
      } finally {
        image.dataset.opticalProcessing = 'false';
      }
    };

    const positionAllOpticalImages = (root) => {
      root.querySelectorAll('.all-forms-card__image[data-optical-ready="true"]').forEach(positionOpticalImage);
    };

    const normalizeOpticalImages = (root) => {
      root.dataset.opticalNormalization = 'active';
      root.querySelectorAll('.all-forms-card__image:not([data-optical-ready])').forEach(normalizeOpticalImage);
    };

    const scheduleOpticalPositioning = (root) => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => positionAllOpticalImages(root));
      });
    };

    const observeOpticalGrid = (root) => {
      if (!('ResizeObserver' in window) || opticalResizeObservers.has(root)) return;

      const grid = root.querySelector('[data-all-forms-grid]');
      if (!grid) return;

      let resizeFrame;
      const observer = new ResizeObserver(() => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => positionAllOpticalImages(root));
      });

      observer.observe(grid);
      opticalResizeObservers.set(root, observer);
    };

    const setDensity = (root, expanded, persist = false) => {
      const button = root.querySelector('[data-all-forms-density-toggle]');
      const label = root.querySelector('[data-all-forms-density-label]');
      const nextLabel = expanded ? 'Reduce product image size' : 'Increase product image size';

      root.dataset.density = expanded ? 'expanded' : 'default';

      if (button) {
        button.setAttribute('aria-pressed', expanded ? 'true' : 'false');
        button.setAttribute('aria-label', nextLabel);
      }

      if (label) label.textContent = nextLabel;
      if (persist) writeStoredDensity(expanded);
      scheduleOpticalPositioning(root);
    };

    const initializePinchDensity = (root) => {
      const grid = root.querySelector('[data-all-forms-grid]');
      if (!grid || grid.dataset.pinchDensityInitialized === 'true') return;

      grid.dataset.pinchDensityInitialized = 'true';

      let gesture = null;
      let suppressClickUntil = 0;

      const touchDistance = (touches) => {
        const first = touches[0];
        const second = touches[1];
        return Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY);
      };

      const finishGesture = (event) => {
        if (!gesture) return;
        if (event.touches && event.touches.length >= 2) return;

        gesture = null;
        root.removeAttribute('data-pinching');
        suppressClickUntil = Date.now() + 420;
      };

      grid.addEventListener(
        'touchstart',
        (event) => {
          if (getViewportMode() !== 'mobile' || event.touches.length !== 2) return;

          const startDistance = touchDistance(event.touches);
          if (!Number.isFinite(startDistance) || startDistance < 24) return;

          gesture = {
            startDistance,
            startedExpanded: root.dataset.density === 'expanded',
            committed: false,
          };

          root.dataset.pinching = 'true';
          event.preventDefault();
        },
        { passive: false }
      );

      grid.addEventListener(
        'touchmove',
        (event) => {
          if (!gesture || event.touches.length !== 2) return;

          event.preventDefault();

          const currentDistance = touchDistance(event.touches);
          const ratio = currentDistance / gesture.startDistance;

          if (!Number.isFinite(ratio) || gesture.committed) return;

          // Pinch out = zoom into a two-column grid. Pinch in = return to three columns.
          if (!gesture.startedExpanded && ratio >= 1.13) {
            gesture.committed = true;
            setDensity(root, true, true);
          } else if (gesture.startedExpanded && ratio <= 0.88) {
            gesture.committed = true;
            setDensity(root, false, true);
          }
        },
        { passive: false }
      );

      grid.addEventListener('touchend', finishGesture, { passive: true });
      grid.addEventListener('touchcancel', finishGesture, { passive: true });

      grid.addEventListener(
        'click',
        (event) => {
          if (Date.now() >= suppressClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    };

    const loadRemainingProducts = async (root) => {
      let nextUrl = root.dataset.nextUrl;
      const grid = root.querySelector('[data-all-forms-grid]');

      if (!nextUrl || !grid || root.dataset.loadingPages === 'true') return;

      root.dataset.loadingPages = 'true';
      grid.setAttribute('aria-busy', 'true');

      const seenProducts = new Set(
        Array.from(grid.querySelectorAll('[data-all-forms-product-id]')).map((item) => item.dataset.allFormsProductId)
      );

      try {
        while (nextUrl) {
          const response = await fetch(nextUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) break;

          const markup = await response.text();
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const nextRoot = parsed.querySelector(SELECTOR);
          const nextGrid = nextRoot?.querySelector('[data-all-forms-grid]');

          if (!nextRoot || !nextGrid) break;

          const fragment = document.createDocumentFragment();
          const nextItems = nextGrid.querySelectorAll('[data-all-forms-product-id]');

          for (const item of nextItems) {
            const productId = item.dataset.allFormsProductId;
            if (!productId || seenProducts.has(productId)) continue;

            seenProducts.add(productId);
            fragment.appendChild(document.importNode(item, true));
          }

          grid.appendChild(fragment);
          normalizeOpticalImages(root);
          scheduleOpticalPositioning(root);
          nextUrl = nextRoot.dataset.nextUrl || '';
          root.dataset.nextUrl = nextUrl;

          await new Promise((resolve) => {
            if ('requestIdleCallback' in window) {
              window.requestIdleCallback(resolve, { timeout: 250 });
            } else {
              window.setTimeout(resolve, 32);
            }
          });
        }
      } catch (error) {
        // The first 50 products remain usable if a later page cannot be fetched.
      } finally {
        grid.setAttribute('aria-busy', 'false');
        root.dataset.loadingPages = 'false';
      }
    };

    const initialize = (root) => {
      if (!root || root.dataset.allFormsInitialized === 'true') return;

      root.dataset.allFormsInitialized = 'true';

      const button = root.querySelector('[data-all-forms-density-toggle]');
      let viewportMode = getViewportMode();

      normalizeOpticalImages(root);
      observeOpticalGrid(root);
      initializePinchDensity(root);
      setDensity(root, readStoredDensity(), false);

      button?.addEventListener('click', () => {
        const expanded = root.dataset.density !== 'expanded';
        setDensity(root, expanded, true);
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          const nextMode = getViewportMode();
          if (nextMode === viewportMode) return;

          viewportMode = nextMode;
          setDensity(root, readStoredDensity(), false);
        }, 120);
      });

      const beginLoading = () => loadRemainingProducts(root);

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(beginLoading, { timeout: 1200 });
      } else {
        window.setTimeout(beginLoading, 350);
      }
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.(SELECTOR)) initialize(scope);
      scope.querySelectorAll(SELECTOR).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
